import { 
  CREATE_COURSE, 
  EDIT_COURSE, 
  GET_ALL_COURSES, 
  GET_ALL_CREATED_COURSES, 
  CLEAR_ALL_COURSES, 
  DELETE_COURSE,
  UPDATE_COURSE_STATUS,
  GET_COURSE,
  GET_COURSE_FEED,
  GET_PUBLIC_COURSES,
  GET_VISIBLE_COURSES,
  GET_ENROLLED_COURSES,
  ENROLL_COURSE,
  UPDATE_CURRENT_COURSE_STATUS,
  MARK_AS_COMPLETED,
  MARK_AS_UNCOMPLETED,
  GET_COURSE_PROGRESS,
  CREATE_SECTION,
  UPDATE_SECTION,
  DELETE_SECTION,
  CREATE_LECTURE,
  UPDATE_LECTURE,
  DELETE_LECTURE,
  UPDATE_COURSE,
  CREATE_TEMPLATE,
  GET_TEMPLATE,
  CREATE_QUIZ,
  SET_TITLE_AND_INSTRUCTION,
  SET_QUESTIONS,
  GET_QUIZ
} from "../constants/actionTypes";
import { 
  CREATE_COURSE_MUTATION, 
  EDIT_COURSE_MUTATION, 
  DELETE_COURSE_MUTATION,
  UPDATE_COURSE_STATUS_MUTATION,
  ENROLL_COURSE_MUTATION,  
  UPDATE_COURSE_MUTATION,
  PUBLISH_COURSE_AND_SECTION_MUTATION,
  CREATE_TEMPLATE_MUTATION,
  GET_TEMPLATE_QUERY,
  CREATE_QUIZ_MUTATION,
  GET_QUIZ_QUERY
} from "../../graphql/mutations/courseMonetisation";
import { MARK_AS_COMPLETED_MUTATION, 
  MARK_AS_UNCOMPLETED_MUTATION,
  CREATE_SECTION_MUTATION,
  UPDATE_SECTION_MUTATION,
  DELETE_SECTION_MUTATION,
  CREATE_LECTURE_MUTATION,
  UPDATE_LECTURE_MUTATION,
  DELETE_LECTURE_MUTATION,
  DELETE_COURSE_SECTION_MUTATION,
  DELETE_COURSE_LECTURE_MUTATION,
  } from "../../graphql/mutations/courseLecturePlan";

import { GET_ALL_COURSES_QUERY,GET_COURSE_PROGRESS_QUERY,GET_COURSE_QUERY} from "../../graphql/queries/courseMonetisation.js";
import { errorMessageFromResponse } from "../constants/commonFunctions";
import { store } from "../store";
import { handleErrorMessage } from "./classes";
import { handleSuccessMessage } from "./success";
import i18n from "../../i18nextConf";
import { request, gql, GraphQLClient } from 'graphql-request';
import axios from "axios";


// import { useTranslation } from 'react-i18next';

// const { t } = useTranslation();

// export const createCourse = (data, routeType) => {

//     const token = store.getState()?.profile?.user?.token;
//     const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
//     const client = new GraphQLClient(endpoint, {
//         headers: {
//             "Authorization": `Token ${token}`,
//         },
//     });

//     const query = CREATE_COURSE_MUTATION;

//     let variables = 
//         {
//             "input": {
//                 "class_id":  data.classes,
//                 "name": data.courseName,
//                 "thumbnail": data.thumbnail,
//                 "description": data.courseDescription,
//                 "subtitle": data.courseSubtitle,
//                 "free": data.isFree,
//                 "public": data.courseType === "Public" ? true : false,
//                 "currency": "usd",
//                 "price": data.priceValue, 
//                 "active": true,
//                 "is_draft": true,
//                 // "media": data.mediaFiles,
//                 // "urls": data.urls
//             }
//         };
  
//     return async (dispatch) => {
//         await client.request(query, variables)
//         .then( async (response) => {
//           if(routeType == "academics"){
//             dispatch(getAllCourses(null,null,null,true))  // getting all created courses
//           } else {
//            await dispatch({
//               type: CREATE_COURSE,
//               payload: response?.createcourse
//             });
//           }        
          
//         }).then(()=>{          
//           const cc = store.getState()?.courses?.currentCourse;
//           console.log('store after dispatch', cc);
//           localStorage.setItem("currentCourse", JSON.stringify(cc));
//           dispatch(handleSuccessMessage(`${i18n.t("courseMonetisation.courseAdded")}`));
//       })
//         .catch(async (error) => {
//             // console.log(error)
//             dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
//             return error;
//         });
//     } 
// }

export const createCourse = (formData, routeType) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  return async (dispatch) => {
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (result.errors) {
        const message =
          result.errors?.[0]?.formatted_message ||
          result.errors?.[0]?.message ||
          "Unknown error";
        dispatch(handleErrorMessage(message));
        return;
      }

      const course = result.data?.createcourse;
      if (routeType === "academics") {
        dispatch(getAllCourses(null, null, null, true));
      } else {
        dispatch({ type: CREATE_COURSE, payload: course });
      }

      
      localStorage.setItem("currentCourse", JSON.stringify(course));
      dispatch(handleSuccessMessage("Course created successfully"));
    } catch (error) {
      dispatch(handleErrorMessage("Something went wrong"));
      console.error("createCourse error:", error);
      return error;
    }
  };
};


export const editCourse = (data) => {
    const token = store.getState()?.profile?.user?.token;
    const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
    const client = new GraphQLClient(endpoint, {
        headers: {
            "Authorization": `Token ${token}`,
            
        },
    });

    const query = EDIT_COURSE_MUTATION;
  
    let variables = {
        input: {
            id: data.courseId,

            ...(data.classes && { class_id: data.classes }),
            ...(data.thumbnail && { thumbnail: data.thumbnail }),
            ...(data.courseName && { name: data.courseName }),
            ...(data.courseSubtitle && { subtitle: data.courseSubtitle }),
            ...(data.courseDescription && { description: data.courseDescription }),

            ...(data.price !== undefined && { price: data.price }),
            ...(data.discounted_price !== undefined && { discounted_price: data.discounted_price }),

            ...(data.course_level && { course_level: data.course_level }),

            ...(data.payment_link && { payment_link: data.payment_link }),
            ...(data.meeting_link && { meeting_link: data.meeting_link }),

            ...(data.active !== undefined && { active: data.active }),

            ...(data.start_time && { start_time: data.start_time }),
            ...(data.repeat && { repeat: data.repeat }),
            ...(data.start_date && { start_date: data.start_date }),
            ...(data.repeat_until && { repeat_until: data.repeat_until }),
            ...(data.repeat_weekdays && { repeat_weekdays: data.repeat_weekdays }),
            ...(data.repeat_monthly_date && { repeat_monthly_date: data.repeat_monthly_date }),

            ...(data.prerequisites && { prerequisites: data.prerequisites }),
            ...(data.learning_outcomes && { learning_outcomes: data.learning_outcomes }),
            ...(data.tags && { tags: data.tags }),

            ...(data.timezone && { timezone: data.timezone }),

            ...(data.preview_video_link && { preview_video_link: data.preview_video_link }),

            ...(data.mediaFiles && { media: data.mediaFiles }),
            ...(data.urls && { urls: data.urls }),
            ...(data.deleteUrls && { deletedUrlIds: data.deleteUrls }),
            ...(data.deleteMediaFiles && { deletedMediaIds: data.deleteMediaFiles }),

            ...(data.paymentLink && { paymentLink: data.paymentLink }),

            ...(data.public !== undefined && { public: data.public })
        }
    };

    return async (dispatch) => {
        await client.request(query, variables)
        .then((response) => {
        dispatch({
            type: EDIT_COURSE,
            payload: response?.updatecourse
        });
        dispatch(
            handleSuccessMessage(`${i18n.t("courseMonetisation.courseUpdate")}`) 
        );
        })
        .catch(async (error) => {
            dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
            return error;
        });
    }
};

export const getAllCourses = (classId=undefined, isPublic=undefined, isEnrolled=undefined, isFaculty=false, isFeed=false, isExploring=false, limit=10000000) =>{
  const token = store.getState()?.profile?.user?.token || localStorage.getItem("token");
    const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
    const endCursor = store.getState()?.courses?.endCursor;

    const client = new GraphQLClient(endpoint, {
      headers: {
        "Authorization": `Token ${token}`,
      },
    });

    const query = GET_ALL_COURSES_QUERY;

    let variables = {
      "input": {
         "class_id" : [classId],
         "public": isPublic,
         "enrolled": isEnrolled,
        //  "is_draft": false,
         "page": {
           "first": isFeed ? 10 : limit,  
          //  "first": limit,  
           //  "after": endCursor == "" ? null : endCursor,
           "after": null,
         }

       }
   }
   if(classId == undefined  || classId == null){
    delete variables.input.class_id;
   }

   if(isPublic !== true  && isPublic !== false){
    delete variables.input.public;
   }

   if(isEnrolled !== true && isEnrolled !== false){
    delete variables.input.enrolled;
   }

   if(isFaculty){
    delete variables.input.is_draft;
   }
   
    return async (dispatch) => {
      await client.request(query, variables)
      .then((response) => {
        // console.log("THE-RESPONSE",response.allcourses.edges)
        if(isFeed === true){
          dispatch({
            type: GET_COURSE_FEED,
            payload: response?.allcourses, // Payload
          });
        } else if (isExploring === true) {
          dispatch({
            type: GET_ALL_COURSES,
            payload: response?.allcourses?.edges, // Payload
          });
        } else if (isPublic === true) {
          dispatch({
            type: GET_PUBLIC_COURSES,
            payload: response?.allcourses?.edges, // Payload
          });               
        } else if (isPublic === false) {
          dispatch({
            type: GET_VISIBLE_COURSES,
            payload: response?.allcourses?.edges,
          });
        } else if (isFaculty === true) {
          let createdCourses = response?.allcourses?.edges.filter((course)=>
            course?.owner?.id == store.getState()?.profile?.profileId
          )
          
          let enrolledCourses = response?.allcourses?.edges.filter((course)=>
            course?.is_enrolled === true
          )

          dispatch({
            type: GET_ENROLLED_COURSES,
            payload: enrolledCourses, // Payload
          });

          dispatch({
            type: GET_ALL_CREATED_COURSES,
            payload: createdCourses, // Payload
          });
          
          
        } else {
          dispatch({
            type: GET_ENROLLED_COURSES,
            payload: response?.allcourses?.edges, // Payload
          });
        }
        
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
   }
}

export const clearCourses = () => {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_ALL_COURSES,
    })
  }
}

export const deleteCourse = (courseID) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = DELETE_COURSE_MUTATION;

  let variables = {
    "input": courseID 
  }

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        dispatch({
          type: DELETE_COURSE,
          payload: courseID,
        })        
        dispatch(
          handleSuccessMessage(
            i18n.t("courseMonetisation.courseDeleted")
          )
        )
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }
};

export const updateCourseStatus = (courseID, isActive, isFeed=true) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = UPDATE_COURSE_STATUS_MUTATION;

  let variables = {
    "input":{
      "id": courseID,
      "active": isActive
    }
   }

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        if(isFeed){
          dispatch({
            type: UPDATE_COURSE_STATUS,
            payload: response?.updatecourse, // it has payload.id and pyload.active
          })
        } else {
          dispatch({
            type: UPDATE_CURRENT_COURSE_STATUS,
            payload: response?.updatecourse, // it has payload.id and pyload.active
          })

        }
        
        if(response?.updatecourse?.active == true) {
          dispatch(handleSuccessMessage(i18n.t("courseMonetisation.courseActivated")))
        } else {
          dispatch(handleSuccessMessage(i18n.t("courseMonetisation.courseInactivated")))
        }         
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }
};

export const getCourseDetails = (id) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = GET_COURSE_QUERY;

  let variables = {id}

  return async (dispatch) => {
      await client.request(query, variables)
      .then((response) => {
      // console.log("THE-RESPONSE",response.getCoursesById)
      dispatch({
          type: GET_COURSE,
          payload: response.getCoursesById, // Payload
      });
      })
      .catch(async (error) => {
      dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
      return error;
      });

  }
};


export const buyCourse = (success, id, data, free) => {

  data = data ? data : "";
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = ENROLL_COURSE_MUTATION;

  let variables = {};

  if(free){
    variables={
      "input":{
        "success": success,
        "successinput": {
        "razorpay_order_id":data
        } ,
      },
      "id":id
    }
  }

  else if(success){
    variables = {
      "input":{
        "success": success,
        "successinput": data ,
      },
    
      "id":id
    };
  }
  else{
    variables = {
      "input":{
        "success": success,
        "failedinput":data 
      },
    
      "id":id
    };
  }





  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        // console.log("response::",response)
        if(response.enrollcourse.message === i18n.t("courseMonetisation.paymentFailure")){
          dispatch(handleErrorMessage(response.enrollcourse.message));
        } 
        else {
          dispatch({
            type: ENROLL_COURSE,
            payload: response // it has status and message
          })        
          dispatch(
            handleSuccessMessage(
              i18n.t("courseMonetisation.coursePaymentDone")
            )
          )
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }
};

export const markAsCompleted = (lectureID, sectionIndex = 0, lectureIndex = 0) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = MARK_AS_COMPLETED_MUTATION;

  let variables = {
    "input": lectureID 
  }

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        dispatch({
          type: MARK_AS_COMPLETED,
          payload: {
            "lecID": lectureID,
            "secIndex": sectionIndex,
            "lecIndex": lectureIndex,
            "progress": response?.completeLecture?.progress_bar,
            "status": response?.completeLecture?.completed
          },
        })        
        dispatch(
          handleSuccessMessage(
            i18n.t("courseMonetisation.markCompleted")
          )
        )
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }

}

export const markAsUncompleted = (lectureID) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = MARK_AS_UNCOMPLETED_MUTATION;

  let variables = {
    "input": lectureID 
  }

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        // dispatch({
        //   type: MARK_AS_UNCOMPLETED,
        //   payload: lectureID,
        // })        
        dispatch(
          handleSuccessMessage(
            i18n.t("courseMonetisation.markUncompleted")
          )
        )
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }

}

// -----------getCourseProgress------------

export const getCourseProgress = (courseID) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = GET_COURSE_PROGRESS_QUERY;

  let variables = {courseID}

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        dispatch({
          type: GET_COURSE_PROGRESS,
          payload: response.getCoursesById?.progress_bar
        })        
        dispatch(
          handleSuccessMessage(
            i18n.t("courseMonetisation.markCompleted")
          )
        )
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }

}

// ----------------------------------

export const createSection = (data) => {

  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
  const client = new GraphQLClient(endpoint, {
      headers: {
          "Authorization": `Token ${token}`,
      },
  });

  const query = CREATE_SECTION_MUTATION;

  let variables = 
      {
        "input" : {
          "course": data.courseID,
          "title": data.title,
        }
      };

  return async (dispatch) => {
  try {
    const response = await client.request(query, variables);

    dispatch({
      type: CREATE_SECTION,
      payload: response?.createSection,
    });

    dispatch(
      handleSuccessMessage(`${i18n.t("courseMonetisation.sectionAdded")}`)
    );

    return response?.createSection;
  } catch (error) {
    dispatch(
      handleErrorMessage(
        errorMessageFromResponse(
          error?.response?.errors[0]?.formatted_message
        )
      )
    );
    return null;
  }
};

}


export const createLecture = (data, sectionID) => {

  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
  const client = new GraphQLClient(endpoint, {
      headers: {
          "Authorization": `Token ${token}`,
      },
  });

  const query = CREATE_LECTURE_MUTATION;

  let variables={
    "input":data,
    "id":sectionID,
  }

  return async (dispatch) => {
      await client.request(query, variables)
      .then((response) => {
        dispatch({
          type: CREATE_LECTURE,
          // payload: response?.createLecture
          payload: {
            lectureData: response?.createLecture,
            sectionID: sectionID
          }
        });       
      dispatch(handleSuccessMessage(`${i18n.t("courseMonetisation.lectureAdded")}`));        
      
    })
      .catch(async (error) => {
          // console.log(error)
          dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
          return error;
      });
  } 
}

export const publishCourse = (courseID) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = PUBLISH_COURSE_AND_SECTION_MUTATION;

  let variables = {
    "input":courseID
   }

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{        
        if(response?.pubCourseandSection?.is_draft === false) {
          dispatch(handleSuccessMessage(i18n.t("courseMonetisation.coursePublished")))
        } else if (response?.pubCourseandSection?.is_draft === true) {
          dispatch(handleSuccessMessage(i18n.t("courseMonetisation.courseSaved")))
        }         
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }
};

export const deleteSection = (sectionID) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = DELETE_COURSE_SECTION_MUTATION;

  let variables = {
    "input": [sectionID] 
  }

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        dispatch({
          type: DELETE_SECTION,
          payload: sectionID,
        })        
        dispatch(
          handleSuccessMessage(
            i18n.t("courseMonetisation.sectionDeleted")
          )
        )
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }
};

export const deleteLecture = (sectionID, lectureID) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = DELETE_COURSE_LECTURE_MUTATION;

  let variables = {
    "input": [lectureID] 
  }

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response)=>{
        dispatch({
          type: DELETE_LECTURE,
          payload: {"sectionID": sectionID, "lectureID": lectureID },
        })        
        dispatch(
          handleSuccessMessage(
            i18n.t("courseMonetisation.lectureDeleted")
          )
        )
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  }
};

export const updateCourse = (data, status) => {

  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
  const client = new GraphQLClient(endpoint, {
      headers: {
          "Authorization": `Token ${token}`,
      },
  });

  const query = EDIT_COURSE_MUTATION;

  const inputData = {
    "id": data.id, 
    "class_id": data.classes,
    "name": data.courseName,
    "description": data.courseDescription,
    "subtitle": data.courseSubtitle,
    "price": data.priceValue, 
    // "active": data.active,
    "is_draft": status,
  }

    if(data.thumbnail) {
      inputData.thumbnail = data.thumbnail
    }

  let variables = 
      {
          "input": inputData
      };

  return async (dispatch) => {
      await client.request(query, variables)
      .then((response)=>{
        localStorage.setItem("currentCourse", JSON.stringify(response?.updatecourse));
        dispatch(handleSuccessMessage(`${i18n.t("courseMonetisation.courseUpdate")}`));
    })
      .catch(async (error) => {
          // console.log(error)
          dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
          return error;
      });
  } 
}

export const updateSection = (data) => {

  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
  const client = new GraphQLClient(endpoint, {
      headers: {
          "Authorization": `Token ${token}`,
      },
  });

  const query = UPDATE_SECTION_MUTATION;

  let variables = 
      {
        "input" : {
          "title": data.title
        },
        "id": data.sectionID,
      };

  return async (dispatch) => {
      await client.request(query, variables)
      .then((response) => {
        dispatch({
          type: UPDATE_SECTION,
          payload: {
            "sectionID": data.sectionID, 
            "sectionData": response?.updateSection
          }
        });       
      dispatch(handleSuccessMessage(`${i18n.t("courseMonetisation.sectionUpdated")}`));        
      
    })
      .catch(async (error) => {
          // console.log(error)
          dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
          return error;
      });
  } 
}

export const updateLecture = (lectureID, sectionID, data) => {

  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;
  const client = new GraphQLClient(endpoint, {
      headers: {
          "Authorization": `Token ${token}`,
      },
  });

  const query = UPDATE_LECTURE_MUTATION;

  let variables = 
      {
        "id": lectureID,
        "input" : data,
      };

  return async (dispatch) => {
      await client.request(query, variables)
      .then((response) => {
        dispatch({
          type: UPDATE_LECTURE,
          payload: {
            "lectureID": lectureID, 
            "sectionID": sectionID,
            "lectureData": response?.updateLecture
          }
        });       
      dispatch(handleSuccessMessage(`${i18n.t("courseMonetisation.lectureUpdated")}`));        
      
    })
      .catch(async (error) => {
          // console.log(error)
          dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
          return error;
      });
  } 
}

// Quiz (multipart-aware: detects File objects and sends GraphQL multipart request)
export const createTemplate = (data) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const variables = {
    input: {
      title: data.title,
      details: data.details,
      questions: data.questions,
    },
  };

  /**
   * Walk the variables object, replacing File/Blob instances with null in the clone
   * and collecting files into filesMap { "<key>": { file, paths: [...] } }
   * paths are strings like "variables.input.questions.0.choice.1.img"
   *
   * Special handling:
   * - If a File/Blob is found at a key named "_file", we'll map it to the sibling ".img" path
   *   (common pattern: editors keep binary under _file while img keeps preview URL).
   */
  function collectFilesAndClone(obj, basePath = "variables") {
    let counter = 0; // will increment before use
    const filesMap = {}; // key -> { file, paths: [] }

    function isFileLike(v) {
      // File is a subclass of Blob in browsers, so checking instanceof Blob covers File as well.
      return typeof Blob !== "undefined" && v instanceof Blob;
    }

    function walker(value, path) {
      // If the value itself is a File/Blob, map it.
      if (isFileLike(value)) {
        counter += 1;
        const key = String(counter);
        // When the actual path ends with '._file', convert to '.img' for server mapping
        const mappedPath = path.endsWith("._file") ? path.replace(/\.?_file$/, ".img") : path;
        filesMap[key] = filesMap[key] || { file: value, paths: [] };
        filesMap[key].paths.push(mappedPath);
        // Return null placeholder in clone (server expects null in operations.variables at that place)
        return null;
      }

      // Arrays
      if (Array.isArray(value)) {
        return value.map((v, i) => walker(v, `${path}.${i}`));
      }

      // Plain objects: walk keys. Additionally, if an object contains a _file sibling but also has img,
      // we'd like to produce clone where img is null and _file is removed (so server gets img = null)
      if (value && typeof value === "object") {
        const out = {};
        for (const k of Object.keys(value)) {
          // If this property is a File-like, handle above; here we still walk to find nested files.
          const childPath = `${path}.${k}`;
          const child = value[k];

          // If a sibling pattern exists: e.g., { img: "...", _file: File }
          // when we encounter `_file` it will be handled by the isFileLike branch above and mapped to .img
          // but it's possible some code sets _file as plain object; walker covers it.
          out[k] = walker(child, childPath);
        }

        // If out has both img (string preview) and _file (which we replaced with null earlier),
        // we want the clone to present img: null (the place server expects) and remove _file key.
        // But our walker already replaced File at path '...._file' with null and inserted mapping to '... .img',
        // so we should remove the _file key from the clone to avoid sending it.
        if (Object.prototype.hasOwnProperty.call(out, "_file")) {
          // remove _file and ensure img exists as null (if it was present as a preview string)
          delete out["_file"];
          out["img"] = null;
        }

        return out;
      }

      // Primitive (string/number/boolean/null/undefined)
      return value;
    }

    const clone = walker(obj, basePath);
    return { clone, filesMap };
  }

  return async (dispatch) => {
    try {
      // collect files from variables
      const { clone: clonedVariables, filesMap } = collectFilesAndClone(variables);
      const fileKeys = Object.keys(filesMap || {});

      // debug: log what files were found (helpful during dev)
      // console.log("createTemplate - filesMap:", filesMap);

      // If there are no files, call graphql-request as before (fast path)
      if (fileKeys.length === 0) {
        const client = new GraphQLClient(endpoint, {
          headers: {
            Authorization: token ? `Token ${token}` : "",
          },
        });
        const response = await client.request(CREATE_TEMPLATE_MUTATION, variables);
        dispatch({
          type: CREATE_TEMPLATE,
          payload: response?.create_template,
        });
        dispatch(handleSuccessMessage("Template created successfully!"));
        return response;
      }

      // Ensure operations.query is a string (not a gql AST)
      const queryStr =
        typeof CREATE_TEMPLATE_MUTATION === "string"
          ? CREATE_TEMPLATE_MUTATION
          : CREATE_TEMPLATE_MUTATION?.loc?.source?.body || String(CREATE_TEMPLATE_MUTATION);

      // Build multipart payload (operations + map) per GraphQL multipart request spec
      const operations = {
        query: queryStr,
        variables: clonedVariables,
      };

      const map = {};
      Object.keys(filesMap).forEach((k) => {
        map[k] = filesMap[k].paths;
      });

      const form = new FormData();
      form.append("operations", JSON.stringify(operations));
      form.append("map", JSON.stringify(map));

      // append files under numeric keys
      Object.keys(filesMap).forEach((k) => {
        const file = filesMap[k].file;
        form.append(k, file, file.name || `upload-${k}`);
      });

      // debug: optionally inspect before sending
      // console.log("operations", operations);
      // console.log("map", map);

      // send multipart POST to GraphQL endpoint
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: token ? `Token ${token}` : "",
          // DO NOT set Content-Type — browser will set multipart boundary
        },
        body: form,
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(`Upload request failed: ${res.status} ${txt}`);
      }

      const json = await res.json();

      if (json.errors && json.errors.length) {
        const errMsg = json.errors[0]?.formatted_message || json.errors[0]?.message || "Something went wrong!";
        dispatch(handleErrorMessage(errMsg));
        throw new Error(errMsg);
      }

      const payload = json.data?.create_template ?? null;
      dispatch({
        type: CREATE_TEMPLATE,
        payload,
      });
      dispatch(handleSuccessMessage("Template created successfully!"));
      return payload;
    } catch (error) {
      const errMsg = error?.message || "Something went wrong!";
      dispatch(handleErrorMessage(errMsg));
      throw error;
    }
  };
};

export const getTemplates = () => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return async (dispatch) => {
    await client
      .request(GET_TEMPLATE_QUERY)
      .then((response) => {
        dispatch({
          type: GET_TEMPLATE,
          payload: response?.templates,
        });
      })
      .catch((error) => {
        const errMsg =
          error?.response?.errors?.[0]?.formatted_message || "Something went wrong!";
        dispatch(handleErrorMessage(errMsg));
      });
  };

}

export const createQuiz = (data) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  const variables = {
    input: {
      title: data.title,
      details: data.details,
      due_date: data.due_date,
      is_lock: data.is_lock,
      assign_all: data.assign_all,
      // isPublished: data.isPublished,
      is_timed: data.is_timed,
      duration: data.duration,
      question_randomized: data.question_randomized,
      reattempt: data.reattempt,
      show_answers: data.show_answers,
      section_id: data.section_id,
      template: data.template,
    },
  };

  return async (dispatch) => {
    await client
      .request(CREATE_QUIZ_MUTATION, variables)
      .then((response) => {
        dispatch({
          type: CREATE_QUIZ,
          payload: response?.create_quiz,
        });
        dispatch(handleSuccessMessage("Template created successfully!"));
      })
      .catch((error) => {
        const errMsg =
          error?.response?.errors?.[0]?.formatted_message || "Something went wrong!";
        dispatch(handleErrorMessage(errMsg));
      });
  };
};

export const getQuizDetails = (id) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  const query = GET_QUIZ_QUERY;

  const variables = { id };

  return async (dispatch) => {
    await client.request(query, variables)
      .then((response) => {
        dispatch({
          type: GET_QUIZ,
          payload: response,
        });
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors[0]?.formatted_message)));
        return error;
      });
  };
};

// quiz data storing action
export const setTitleAndInstruction = (payload) => ({
  type: SET_TITLE_AND_INSTRUCTION,
  payload, // { title: '', instruction: '' }
});


export const setQuestions = (questions) => ({
  type: SET_QUESTIONS,
  payload: questions, 
});

export const purchaseCourse = (courseId) => async (dispatch, getState) => {
  try {
    // get auth token (from redux or localStorage)
    const token =
      getState()?.auth?.token ||
      JSON.parse(localStorage.getItem("userData"))?.token;

    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}api/v1/course-purchases/`,
      { course: courseId },
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Course purchase failed:", err);
    dispatch(handleErrorMessage("Failed to purchase course"));
    throw err;
  }
};

